import aboutImg from "../assets/images/sponsor_logo/s2_2.jpeg";
import './VideoPage.css';

function AboutHeroesPage() {
  return (
    <div className="container_12">
      <div className="grid_12">
        <div className="grid_12 alpha">
          <div className="box-3">
            <div className="gradient_1">
              <h2>澳大利亚群英气排球俱乐部</h2>
            </div>
            <div
              className="box-3_pad_3 p_text_lineheight"
              style={{
                fontSize: "18px",
                textIndent: "Video0px",
              }}
            >
<img src={aboutImg} alt="" />
<p className="p_text_body" style={{marginTop:"20px"}}>
澳大利亚群英气排球俱乐部成立于2020年12月，是早期在澳洲推广气排球活动的非盈利组织之一，由理事会集体管理。作为一个非盈利的社区组织，群英俱乐部一贯致力于搭建气排球爱好者的优质成长平台，秉承推广气排球的初心。
<br />
<br />
俱乐部有二个固定的训练场地Riverwood和Hurstville，目前每周定期训练4次，每次3小时。俱乐部里有资质的教练员，裁判员及义工队伍，有长期参加训练的俱乐部队伍，和高技术的球员。俱乐部不定期举办不同等级的各种运动员培训班，包括初学者速成班，中级提高班，攻手班 及二传班，以满足球员的进修要求。
<br />
<br />
俱乐部连续两年被邀请参与Open Day for NSW Seniors Festival 活动， 并且向广大的老年朋友示范气排球运动，吸引更多的老年朋友参与到这项运动里。
<br />
<br />
群英俱乐部组织了多次的大型比赛，其中协办了由澳大利亚气排球协会主办的2021年澳大利亚气排球锦标赛；承办了2022，2023年澳大利亚气排球联赛在悉尼南部的全部初赛赛事，协办了8强决赛。另外在2022、2023年承办澳大利亚中国高校校友联盟主办的气排球比赛。2022年成功主办了由乔治河市政府赞助的乔治河群英杯 。 2023年澳洲日在悉尼举办“气排球家庭同乐日”，队伍由家庭成员组成，是近年最大规模的气排球免费公益推广活动。群英俱乐部再次把气排球的运动向不同年龄、不同文化的社区里推广。
<br />
<br />
2023年群英俱乐部又成功地举办了“ACY杯公益推广”有奖比赛，以鼓励澳洲2023年联赛前八强的队伍。
<br />
<br />
群英俱乐部在2023年首届世界气排球锦标赛中，有8支不同组别的队伍获得参赛资格。
2024年群英俱乐部每周六举办擂台赛，让球员积累更多的比赛经验，以备战新一年的联赛。
<br />
<br />
为了更大程度地推广气排球运动，俱乐部还多次与当地市政府沟通，力求让气排球运动被更多的社区人群了解和接受。市政府明确表示乐于支持和帮助推广这项运动，并且在一定范围内付诸了实施。在2023年俱乐部被当地市政府表彰，并正式被乔治河市政府邀请成为Georges River Council Sports Advisory Committee的成员。
<br />
<br />
群英俱乐部以推广气排为己任，以社区公益为宗旨，将会继续不断地推广这项有益身心的群众性体育运动。

</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutHeroesPage;

